/** 확인 대화상자가 확인 버튼을 켤 조건. T1은 바로, T2는 이름 일치, T3는 사유와 기다림. */
export type ConfirmTier = "T1" | "T2" | "T3";

export function confirmReady(input: {
  tier: ConfirmTier;
  typedName: string;
  expectedName: string;
  reason: string;
  secondsLeft: number;
}): boolean {
  if (input.tier === "T1") return true;
  if (input.tier === "T2") {
    const expected = input.expectedName.trim();
    return expected.length > 0 && input.typedName.trim() === expected;
  }
  return input.secondsLeft <= 0 && input.reason.trim().length > 0;
}
